import { useEffect, useState } from "react";
import { CountUp, Reveal } from "@/pages/designPreview/previewMotion";
import { buildAuthoritySpine, loadPreviewCapabilities } from "@/pages/designPreview/previewData";
import { AuthoritySpine, MetricOrbit, SceneIndex } from "@/pages/designPreview/PreviewVisuals";

export default function AuthorityPreview() {
  const [data, setData] = useState(null);
  useEffect(() => {
    loadPreviewCapabilities().then(setData).catch(() => setData(null));
  }, []);
  const metric = data?.authority?.facts?.find((row) => row.metric_value);
  const spine = buildAuthoritySpine(data);

  return (
    <div>
      <section className="dp-scene dp-metric-scene">
        <div className="dp-gridbg" />
        <SceneIndex n={1} />
        <MetricOrbit />
        <p className="dp-kicker">AUTHORITY</p>
        <CountUp className="dp-metric-num" value={metric?.metric_value || "832"} />
        <p className="dp-metric-cap">{metric?.public_label || "누적 프로젝트"}</p>
        <p className="dp-metric-note">{metric?.public_description || metric?.public_summary}</p>
      </section>

      <section className="dp-scene dp-scene--tight">
        <SceneIndex n={2} />
        <Reveal>
          <p className="dp-kicker">TRUST STORY</p>
          <h2 className="dp-display" style={{ fontSize: "clamp(2rem, 5vw, 3.6rem)" }}>기술력의 근거</h2>
          <p className="dp-lead">대표 프로필부터 회사 인증까지, 하나로 연결된 근거입니다.</p>
        </Reveal>
        <div style={{ marginTop: "3rem" }}>
          <AuthoritySpine items={spine} />
        </div>
      </section>
    </div>
  );
}
